var _path, _circle, _circle2, _circle3, _circle4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTifoMascotte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9883 31.4977C12.7741 30.3211 9.55997 29.1444 6.34582 27.9677C5.56965 27.6835 4.77855 27.4293 4.03223 27.0803C2.68885 26.4471 1.96741 25.3452 2.25101 23.8743C2.54954 22.3237 3.61429 21.4063 5.22634 21.3814C8.18177 21.3365 11.1372 21.3664 14.2369 20.8728C11.2168 19.6862 8.19669 18.4996 5.18156 17.3129C4.41036 17.0088 3.65907 16.6498 2.87294 16.3955C0.907634 15.7673 -0.390962 14.6455 0.106584 12.4018C0.589205 10.228 2.34554 10.0086 4.18149 10.0086C12.0527 10.0086 19.9189 10.0086 27.7901 10.0086C30.9395 10.0086 34.084 9.9837 37.2335 10.0186C39.7013 10.0435 41.2835 11.28 41.3134 13.1049C41.3432 14.9297 39.8307 16.2111 37.2882 16.241C31.8351 16.3058 26.382 16.2609 20.7647 16.7944C23.6107 17.9461 26.4517 19.1029 29.3026 20.2496C30.2977 20.6485 31.3127 21.0124 32.3128 21.4113C33.8801 22.0445 34.7508 23.1813 34.4373 24.8964C34.1238 26.6116 32.9447 27.3744 31.2231 27.3645C28.8299 27.3545 26.4368 27.3645 23.5958 27.3645C25.1979 28.5511 26.7552 28.7755 28.1632 29.3189C29.5514 29.8574 30.3972 30.8197 30.4171 32.2755C30.442 33.891 29.4519 34.8832 27.9393 35.282C22.2623 36.7728 16.5903 38.2636 10.8934 39.6746C9.14203 40.1083 7.68422 39.4253 7.18667 37.6304C6.66922 35.7557 7.49018 34.3646 9.38583 33.8062C11.5601 33.163 13.7692 32.6196 15.9634 32.0362C15.9733 31.8567 15.9833 31.6822 15.9982 31.5027L15.9883 31.4977Z",
    fill: "#46F6A6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 7.5,
    r: 7.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 7.5,
    r: 7.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 7.5,
    r: 2.5,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 7.5,
    r: 2.5,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20C13 20 16 24 21 24C26 24 29 20 29 20",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTifoMascotte);
export default __webpack_public_path__ + "static/media/tifo_mascotte.fe164add8e174fbd8b8a9bb8dc345a1c.svg";
export { ForwardRef as ReactComponent };